var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bj-paging-table" },
    [
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            loading: _vm.loading,
            data: _vm.tableData,
            stripe: "",
            border: "",
            size: "mini",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-key": "BJ_EBC_ID",
          },
        },
        [_vm._t("tableColumn")],
        2
      ),
      _vm.pagination
        ? _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  background: _vm.background,
                  "current-page": _vm.pagingInfo.page,
                  "page-size": _vm.pagingInfo.size,
                  layout: _vm.layout,
                  "page-sizes": _vm.pageSizes,
                  total: _vm.pagingInfo.total,
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.pagingInfo, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.pagingInfo, "page", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.pagingInfo, "size", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.pagingInfo, "size", $event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }